function JDSLoader(props) {

    const defaultContent = props.msg || "Just a moment. We are loading the content...";
    return (<div id="loader">
        <div id="loading-dialog" className="modal show" tabIndex="-1" aria-modal="true" style={{ display: 'block' }}>
            <div className="loader-main">
                <div className="loader">Loading...</div>
                <span>{defaultContent}</span>
                {/* <strong><img src="images/sg-courts-logo.svg" alt="" width="240" /></strong> */}
            </div>
        </div>

    </div>);
}

export default JDSLoader;